<template>
  <ModelListPage
          lower-app-name="systemsettings"
          lower-model-name="systemsettings"
          version="1"
          title="系统配置列表">
  </ModelListPage>
</template>

<script>
import ModelListPage from './ModelListPage.vue'

export default {
  name: 'SystemSettingsList',
  components: {
    ModelListPage
  }
}
</script>



// WEBPACK FOOTER //
// SystemSettingsList.vue?b83d4c1e